// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Share from 'church-theme-library/components/Share/Share'

class PageFooter extends React.Component {
	renderContent() {
		const { translate, type } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		// Author:
		let authorsMarkup = null,
			authorsCombinedBioMarkup = null,
			authorsNumber,
			authorsClass

		if ( 'post' == type && page.authors.by_id ) {
			authorsNumber = Object.keys( page.authors.by_id ).length
			authorsClass = '-authors'

			if ( authorsNumber > 1 ) {
				authorsClass += ' has-multiple'
			}

			authorsMarkup = Object.keys( page.authors.by_id ).map( ( key ) => {
				let item = page.authors.by_id[ key ]

				return (
					<div className="-author" key={ key }>
						{ item.image &&
							<div className="-image">
								<img src={ item.image } alt={ item.name } />
							</div>
						}

						<p>{ item.name }</p>

						{ ! page.authors.combined_bio &&
							<div className="-bio" dangerouslySetInnerHTML={ { __html: item.bio } } />
						}
					</div>
				)
			} )

			if ( page.authors.combined_bio ) {
				authorsCombinedBioMarkup = <div className="-combined-bio" dangerouslySetInnerHTML={ { __html: page.authors.combined_bio } } />
			}
		}

		return (
			<div className="page-footer-content">
				{ 'post' == type &&
					<aside className={ authorsClass }>
						{/*<h3>{ translate( 'Written by' ) }</h3>*/}

						<div className="-inner">
							{ authorsMarkup }

							{ authorsCombinedBioMarkup }
						</div>
					</aside>
				}

				{ 'post' == type && false &&
					<aside className="-share-wrap">
						<h3>{ translate( 'Share' ) }</h3>

						<div className="-share">
							<Share type="facebook">
								<i className="icon-facebook-square" aria-hidden="true"></i>
							</Share>

							<Share type="twitter">
								<i className="icon-twitter-square" aria-hidden="true"></i>
							</Share>

							<Share type="google-plus">
								<i className="icon-google-plus" aria-hidden="true"></i>
							</Share>
						</div>
					</aside>
				}
			</div>
		)
	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		if ( this.props.isLoading ) {
			return null
		} else {
			return (
				<div className="page-footer">
					{ this.renderContent() }
				</div>
			)
		}

	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected
	}
}

export default localize(
	connect( mapStateToProps )( PageFooter )
)
